export { useColorPickerBase_unstable as useColorPicker } from '@fluentui/react-color-picker';
